// Product Callout
SP.ProductCallout = Garnish.Base.extend({
    $el: null,
    $elementContent: null,

    height: null,

    init(el) {
        this.$el = $(el)
        this.$elementContent = this.$el.find('.element-content')

        this.height = this.$elementContent.height() + 10
        this.$elementContent.css('bottom', '-' + this.height + 'px')

        this.addListener(Garnish.$win, 'resize', 'updateSizeAndPosition');
    },

    updateSizeAndPosition() {
        Garnish.$bod.addClass('is-resizing')
        clearTimeout(resizeTimer)

        let resizeTimer = setTimeout(function () {
            Garnish.$bod.removeClass('is-resizing')
        }, 100)

        this.height = this.$elementContent.height() + 10
        this.$elementContent.css('bottom', '-' + this.height + 'px')
    }
})

// Page Callout
SP.PageCallout = Garnish.Base.extend({
    $el: null,
    $elementContent: null,

    height: null,

    init(el) {
        this.$el = $(el)
        this.$elementContent = this.$el.find('.element-content')

        this.height = this.$elementContent.height() + 10
        this.$elementContent.css('bottom', '-' + this.height + 'px')

        this.addListener(Garnish.$win, 'resize', 'updateSizeAndPosition');
    },

    updateSizeAndPosition() {
        Garnish.$bod.addClass('is-resizing')
        clearTimeout(resizeTimer)

        let resizeTimer = setTimeout(function () {
            Garnish.$bod.removeClass('is-resizing')
        }, 100)

        this.height = this.$elementContent.height() + 10
        this.$elementContent.css('bottom', '-' + this.height + 'px')
    }
})

SP.ResetCollectionPageScripts = Garnish.Base.extend({
    init() {
        $('html, body').animate({scrollTop: 0}, 100)

        // Product Tiles
        let productTiles = $('.product-tile')
        if (productTiles.length > 0 ) {
            $.each(productTiles, function (index, el) {
                new SP.ProductTile(el)
            })
        }

        $('body').removeClass('remove-scrolling')
    }
})

SP.OptionRadioGroup = Garnish.Base.extend({
    domNode: null,
    parentNode: null,
    radioButtons: null,
    firstRadioButton: null,
    lastRadioButton: null,

    defaultVariant: null,

    init(domNode, parentNode) {
        this.domNode = domNode
        this.parentNode = parentNode
        this.radioButtons = []
        this.defaultVariant = this.parentNode.variant

        if (!this.domNode.getAttribute('role')) {
            this.domNode.setAttribute('role', 'radiogroup')
        }

        let rbs = this.domNode.querySelectorAll('[role=radio]')

        for (let i = 0; i < rbs.length; i++) {
            let rb = new SP.OptionRadioButton(rbs[i], this)
            this.radioButtons.push(rb)

            if (!this.firstRadioButton) {
                this.firstRadioButton = rb
            }

            this.lastRadioButton = rb
        }
    },

    setChecked(currentItem) {
        for (let i = 0; i < this.radioButtons.length; i++) {
            let rb = this.radioButtons[i]
            rb.domNode.setAttribute('aria-checked', 'false')
            rb.domNode.tabIndex = -1
        }

        currentItem.domNode.setAttribute('aria-checked', 'true')
        currentItem.domNode.tabIndex = 0
        currentItem.domNode.focus()

        let variantName = ''
        $.each($('.product-option [aria-checked="true"]'), function (i, el) {
            if (variantName !== '') {
                variantName = variantName + ' / ' + el.dataset.variantName
            } else {
                variantName = el.dataset.variantName
            }
        })

        // let variant = this.parentNode.product.variants.find(v => v.title === variantName)
        // this.parentNode.$productSelectInput.val(variant.id).trigger('change')

        let variant = null
        let productSelectorInput = null
        if (this.parentNode.product) {
            variant = this.parentNode.product.variants.find(v => v.title === variantName)
            productSelectorInput = this.parentNode.$productSelectInput
        } else {
            variant = product.variants.find(v => v.title === variantName)
            productSelectorInput = $('#product-select')
        }

        if (variant) {
            let variantId = variant.id
            productSelectorInput.val(variantId).trigger('change')
        }
    },

    setCheckedToPreviousItem(currentItem) {
        let index

        if (currentItem === this.firstRadioButton) {
            this.setChecked(this.lastRadioButton)
        } else {
            index = this.radioButtons.indexOf(currentItem)
            this.setChecked(this.radioButtons[index - 1])
        }
    },

    setCheckedToNextItem(currentItem) {
        let index

        if (currentItem === this.lastRadioButton) {
            this.setChecked(this.firstRadioButton)
        } else {
            index = this.radioButtons.indexOf(currentItem);
            this.setChecked(this.radioButtons[index + 1])
        }
    }
})

SP.OptionRadioButton = Garnish.Base.extend({
    domNode: null,
    radioGroup: null,
    keyCode: Object.freeze({
        'RETURN': 13,
        'SPACE': 32,
        'END': 35,
        'HOME': 36,
        'LEFT': 37,
        'UP': 38,
        'RIGHT': 39,
        'DOWN': 40
    }),

    defaultVariant: null,

    init(domNode, groupObj) {
        this.domNode = domNode
        this.radioGroup = groupObj
        this.defaultVariant = groupObj.defaultVariant
        this.domNode.tabIndex = -1
        this.domNode.setAttribute('aria-checked', 'false')

        this.setOptions()

        this.addListener(this.domNode, 'keydown', this.handleKeydown)
        this.addListener(this.domNode, 'click', this.handleClick)
        this.addListener(this.domNode, 'focus', this.handleFocus)
        this.addListener(this.domNode, 'blur', this.handleBlur)
    },

    setOptions() {
        let options = this.defaultVariant.options

        if (options) {
            for (let i = 0; i < options.length; i++) {
                let optionValue = options[i]
                let el = $(`[data-variant-name="${optionValue}"]`)
                el.attr('aria-checked', 'true')
                el.attr('tabindex', '0')
            }
        }
    },

    handleKeydown(event) {
        let tgt = event.currentTarget
        let flag = false
        let clickEvent

        switch (event.keyCode) {
            case this.keyCode.SPACE:
            case this.keyCode.RETURN:
                this.radioGroup.setChecked(this)
                flag = true
                break

            case this.keyCode.UP:
                this.radioGroup.setCheckedToPreviousItem(this)
                flag = true
                break

            case this.keyCode.DOWN:
                this.radioGroup.setCheckedToNextItem(this)
                flag = true
                break

            case this.keyCode.LEFT:
                this.radioGroup.setCheckedToPreviousItem(this)
                flag = true
                break

            case this.keyCode.RIGHT:
                this.radioGroup.setCheckedToNextItem(this)
                flag = true
                break

            default:
                break
        }

        if (flag) {
            event.stopPropagation()
            event.preventDefault()
        }
    },

    handleClick(event) {
        this.radioGroup.setChecked(this)
    },

    handleFocus(event) {
        this.domNode.classList.add('focus')
    },

    handleBlur(event) {
        this.domNode.classList.remove('focus')
    },
})




/**
 * Slugify function
 */

function slugify(text) {
    return text.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-')
}
